import request from './request'

const applyAccount = (obj) => request({ data: obj }, '/app/insertMosPublic') // 获取体验帐号

export {
  applyAccount
}



// WEBPACK FOOTER //
// ./src/api/joinUs.js